import { TRIGGER_TOAST, RESET_TOAST } from "./../constants";

const showToastMessage = (shouldShow: boolean, severity: string, transMessage: string) => {  
  return (dispatch: any) => {
    dispatch({
      type: TRIGGER_TOAST,
      payload: {
        shouldShow,
        severity,
        transMessage
      },
    });
  };
};
const resetToastMessage = (shouldShow: boolean, severity: string, transMessage: string) => {  
  return (dispatch: any) => {
    dispatch({
      type: RESET_TOAST,
      payload: {
        shouldShow,
        severity,
        transMessage
      },
    });
  };
};


export default {
  showToastMessage,
  resetToastMessage
};
